module.exports = __webpack_public_path__ + "img/symbol_2.47120e85.png";